export var MetadataType = /*#__PURE__*/ function(MetadataType) {
    MetadataType["PodBegin"] = "PodBegin";
    MetadataType["PrerollPodBegin"] = "PrerollPodBegin";
    MetadataType["PodEnd"] = "PodEnd";
    MetadataType["PrerollPodEnd"] = "PrerollPodEnd";
    MetadataType["AdBegin"] = "AdBegin";
    MetadataType["AdEnd"] = "AdEnd";
    // Not 100% sure this event exists, but it would make sense if it did.
    MetadataType["NonLinearPod"] = "NonLinearPod";
    return MetadataType;
}({});
export var JsonAdBreakTrackingEvent = /*#__PURE__*/ function(JsonAdBreakTrackingEvent) {
    JsonAdBreakTrackingEvent["BREAK_START"] = "BREAK_START";
    JsonAdBreakTrackingEvent["BREAK_END"] = "BREAK_END";
    JsonAdBreakTrackingEvent["breakStart"] = "breakStart";
    JsonAdBreakTrackingEvent["breakEnd"] = "breakEnd";
    return JsonAdBreakTrackingEvent;
}({});
export var MediaTailorErrorCodes = /*#__PURE__*/ function(MediaTailorErrorCodes) {
    MediaTailorErrorCodes["BAD_HTTP_RESPONSE_CODE"] = "MT_BAD_HTTP_RESPONSE_CODE";
    MediaTailorErrorCodes["NETWORK_ERROR"] = "MT_NETWORK_ERROR";
    MediaTailorErrorCodes["PARSE_ERROR"] = "MT_PARSE_ERROR";
    MediaTailorErrorCodes["TIMEOUT"] = "MT_TIMEOUT";
    MediaTailorErrorCodes["DESTROYED"] = "MT_DESTROYED";
    MediaTailorErrorCodes["INTERVAL_EXCEEDED"] = "MT_INTERVAL_EXCEEDED";
    return MediaTailorErrorCodes;
}({});

//# sourceMappingURL=ad-breaks-provider.enums.js.map